import { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import { PPDialog } from 'components/PPDialog'
import { FormattedMessage } from 'react-intl'

import styles from './ErrorFallback.pcss'

export interface ErrorFallbackProps {
  error: Error
  resetErrorBoundary: () => void
}

export function ErrorFallback(props: ErrorFallbackProps) {
  const [errorVisible, setErrorVisible] = useState(false)
  const isWebpackError = /loading.*chunk|chunkloaderror/i.test(props.error.message || '')

  useEffect(() => {
    // Reload the page if it's a webpack chunk loading error
    if (isWebpackError) {
      // prevent infinite reload loops
      if (!sessionStorage.getItem('chunk-reload')) {
        sessionStorage.setItem('chunk-reload', 'true')
        setTimeout(() => window.location.reload(), 50) // eslint-disable-line no-magic-numbers
      }
    }
  }, [isWebpackError])

  const toggleError = () => {
    setErrorVisible(current => !current)
  }

  if (isWebpackError) {
    return <div>Reloading app...</div>
  }

  return (
    <PPDialog
      open
      dismissible={false}
      size="sm"
      title={<FormattedMessage id="errors.app-crash" />}
      footer={
        <div className={styles['footer-actions']}>
          <a onClick={toggleError}>
            {errorVisible ? 'hide error' : 'see error'}
          </a>
          <Button color="primary" variant="contained" onClick={props.resetErrorBoundary}>
            <FormattedMessage id="actions.refresh" />
          </Button>
        </div>
      }
    >
      <div className={`${styles.message} ${errorVisible ? styles.visible : ''}`}>
        <p>{`Original error: ${props.error.message}`}</p>
        <p>{`Stack trace: ${props.error.stack}`}</p>
      </div>
    </PPDialog>
  )
}
